<script lang="ts">import { focus } from "../../action";
export let enabled;
export let assignAriaHidden = false;
export let element = undefined;
export let focusable = false;
export let focusDelay = undefined;
export let preventScroll = false;
export let delay = undefined;
</script>

<div
	use:focus={{ enabled, assignAriaHidden, element, focusable, focusDelay, preventScroll, delay }}
>
	<slot />
</div>
